import { render, staticRenderFns } from "./CourseEvent.vue?vue&type=template&id=381c7f4c&"
import script from "./CourseEvent.vue?vue&type=script&lang=js&"
export * from "./CourseEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports